export default __webpack_public_path__ + "static/media/port-logo-apvs.f6176920.webp";